import React from "react";
import { Link } from "react-router-dom";

export default function CollectionCard(props) {
    const { data } = props
  return (
    <>
      <Link className="text-decoration-none" to={`/nfts/${data._id}`} state={data.name}>
        <div className="artItemBoxNew nftBox">
          <div className="imgBox position-relative">
            <img src={data?.image?.link} alt="" />
            {/* <div className="collectionCategoryName art">Art</div> */}
          </div>
          <div className="contBox mt-3">
            <div className="arthead mb-2">
              <h2 className="productName"  title={data.name}>{data?.name}</h2>
            </div>
            <p className="collectioncard">
            {data?.description}
            </p>
            <div className="viewAndLike">
              <p>
                <span>Total Artworks </span>
                {data?.totalNfts}
              </p>
             
            </div>
          </div>
        </div>
      </Link>
    </>
  );
}
